<template>
  <div class="found-message">
    {{ $l.cardFound }}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ]
}
</script>

<style lang="scss" scoped>
.found {
  &-message {
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
